import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {HolidayGreetingsService as HolidayGreetingsApiService} from '../../api/services/holiday-greetings.service';
import {catchError, finalize} from 'rxjs/operators';
import {HolidayGreetingsListModel} from '../../api/models/holiday-greetings-list-model';
import {HolidayGreetingsListRequest} from '../../api/models/holiday-greetings-list-request';
import {HolidayGreetingsGridResponse} from '../../api/models/holiday-greetings-grid-response';


export class HolidayGreetingsDatasource implements DataSource<HolidayGreetingsListModel> {

  constructor(private pbxApiService: HolidayGreetingsApiService) {
  }

  private dataSubject = new BehaviorSubject<HolidayGreetingsListModel[]>([]);
  private dataTotalSubject = new BehaviorSubject<number>(0);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();
  public dataCount$ = this.dataTotalSubject.asObservable();

  connect(collectionViewer: CollectionViewer): Observable<HolidayGreetingsListModel[] | ReadonlyArray<HolidayGreetingsListModel>> {
    console.log('Connecting data source');
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    console.log('Disconnecting data source');
    this.dataSubject.complete();
    this.loadingSubject.complete();
    this.dataTotalSubject.complete();
  }

  public currentPageData(): HolidayGreetingsListModel[] {
    return this.dataSubject.getValue();
  }

  public queryData(state: HolidayGreetingsListRequest): void {
    console.log('query phone numbers');
    this.loadingSubject.next(true);

    // todo: this.callLogAggregates = {};
    this.pbxApiService
      .pbxHolidayGreetingsGetList({body: state})
      .pipe(
        catchError(() => of({data: [], total: 0})),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe((response: HolidayGreetingsGridResponse) => {
        this.dataTotalSubject.next(response.total);
        this.dataSubject.next(response.data);
      } );
  }
}
